export default __webpack_public_path__ + "static/media/created_by.b64bbfa1.svg";